<template>
  <lu-vbox lu-flex class="app-container">

    <lu-item>
      <!-- <PageHeader :title='$t("Stark")' /> -->
    </lu-item>

  </lu-vbox>

</template>

<script>
import { LuVbox, LuItem } from 'lusis-ui'
// import PageHeader from '@/components/PageHeader'


export default {
  name: 'Home',
  components: { LuVbox, LuItem }
}
</script>

<style lang="scss" scoped>
.home {
  &-container {
    margin: 30px;
  }
  &-text {
    line-height: 46px;
  }
}
</style>
